// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__VkIEL","tabContainer":"Home_tabContainer__OWE3m","tabSelect":"Home_tabSelect__Kosnu","tabContent":"Home_tabContent__rLu5Q","hint":"Home_hint__9PCFr"};